<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowPage">
<div class="title-acknowPage"><a href="#/e9781466822931_toc01#toctitle1" id="title1"><span><strong class="b">Acknowledgments</strong></span></a></div>
<div class="p"><span>Thanks to Alicia, Jacob, Sarah, Adam, Amelia Wolf, Susan Jackson, and Nicolyn and George Rau for their love, PJ Grim for all of her support, Paul Humbert for his patience, Dr. Ed Migneco for always being there, Julie Castiglia for her help, Sally Kim, editor at Thomas Dunne Books, for her ability to see beyond the words, and the Stray Rescue Family in St. Louis.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466822931_ack01.vue?18ccb6bc